export default __webpack_public_path__ + "static/media/DINPro-Black.c531f968.ttf";